import { render, staticRenderFns } from "./BrainStatistics.vue?vue&type=template&id=5c54de5f&scoped=true&"
import script from "./BrainStatistics.vue?vue&type=script&lang=js&"
export * from "./BrainStatistics.vue?vue&type=script&lang=js&"
import style0 from "./BrainStatistics.vue?vue&type=style&index=0&id=5c54de5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c54de5f",
  null
  
)

export default component.exports